import { render, staticRenderFns } from "./AutorizacaoDiarioCadastro.vue?vue&type=template&id=ce935632&"
import script from "./AutorizacaoDiarioCadastro.vue?vue&type=script&lang=js&"
export * from "./AutorizacaoDiarioCadastro.vue?vue&type=script&lang=js&"
import style0 from "./AutorizacaoDiarioCadastro.vue?vue&type=style&index=0&id=ce935632&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports